/*
 *###############################################################################
 *Module Name                   : LocationMaster.js                            #
 *Purpose of the Module         :                                              #
 *Description of the Module     :                                              #
 *Original Author               : Chathura Prabashwara                         #
 *Date                          : Monday , Octomber 4th 2021, 10:10:07 am      #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                          #
 *###############################################################################
 */


import React, { useEffect, useState, useContext } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  TabContent,
  TabPane,
  Alert
} from "reactstrap"

//**Importing required componant files   */
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import DPNavBar from "../../../framework/widgets/DPNavBar"
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import DPAlert from "../../../framework/widgets/DPAlert"
import LocationMasterGenContent from "./LocationMasterGenContent"   // Content of the General information Tab
import LocationMasterCDContent from "./LocationMasterCDContent"      // Content of the Contact Details information Tab
import { Text, Numeric } from "../../../framework/validators/TextValidation"
import DPInfoBox from "framework/layout/DPInfoBox"
import { DeleteLocationMasterDetails, LocationMasterDetailsGetData, setLocationMaster } from './LocationMasterController'
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import * as XLSX from "xlsx";
import DPPrintOption from "framework/widgets/DPPrintOptions"
import { toUpper } from "lodash"
//**End Importing required componant files */

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';

const LocationMaster = (props) => {
  const [newMenu] = useState(localStorage.getItem(window.location.pathname)) //localStorage.getItem((window.location.pathname).toString())
  let history = useHistory();
  //**Set Values for Genaral Tab (Tab==1) */
  const [IsActive, SetActive] = useState(false)//Set Active state
  const [IsWebActive, SetWebActive] = useState(false)//Set Web Active state
  const [IsRemoteActive, SetRemoteActive] = useState(false)//Set Remote Active state
  const [IsStockActive, SetStockActive] = useState(false)//Set Stock Active state
  const [isCafe, SetIsCafe] = useState(false) //Set Cafe Available Active
  const [isLiquor, SetIsLiquor] = useState(false) //Set Liquor Available Active
  const [isCompete, SetIsCompete] = useState(false) //Set Compete Available Active
  const [isExtLiq, SetIsExtLiq] = useState(false) //Set ExtLiq Available Active
  const [locCode, SetCode] = useState("") //Set code
  const [codeEnable, SetCodeEnable] = useState(false) //Set code enble
  const [locDec, SetDesc] = useState("") //Set Description
  const [locComCode, SetLocComCode] = useState("") //Set Company
  const [loccosCode, SetLoccosCode] = useState("")
  const [loclinkCode, SetLoclinkCode] = useState("")
  const [locAbrCode, SetLocAbrCode] = useState("")
  const [locGrade, SetLocGrade] = useState("")
  const [locGroup, SetLocGroup] = useState("")
  const [locSubGroup, SetLocSubGroup] = useState("")
  const [locIp, SetLocIp] = useState("")
  const [locMap, SetLocMap] = useState("")
  const [locFloor, SetLocFloor] = useState("0.0")
  const [locOther, SetLocOther] = useState("0.0")
  const [locTotal, SetLocTotal] = useState("0.0")
  const [locStaff, SetLocStaff] = useState("0.0")
  const [locParkSlots, SetLocParkSlots] = useState("0")
  const [locPosUnits, SetLocPosUnits] = useState("0")
  const [locBkUnits, SetLocBkUnits] = useState("0")
  const [locMobUnits, SetLocMobUnits] = useState("0")
  const [locOpDate, SetLocOpDate] = useState("")
  const [locClDate, SetLocClDate] = useState("")
  const [locOpFrom, SetLocOpFrom] = useState("")
  const [locOpTo, SetLocOpTo] = useState("")
  const [locGrowth, SetLocGrowth] = useState("0.0")
  const [locCurCode, SetLocCurCode] = useState("")
  const [locMainLoc, SetLocMainLoc] = useState("")
  const [locPrmod, SetLocPrmod] = useState("")
  const [totaldisabled, SetTotaldisabled] = useState(true)
  const [stoleList, setStoleList] = useState([]);
  const [clearData, setClearData] = useState(false)

  //**  Set Values for Contact Details  Tab (Tab==2) */
  const [locAdd, SetLocAdd] = useState("")
  const [locAdd2, SetLocAdd2] = useState("")
  const [locAdd3, SetLocAdd3] = useState("")
  const [locOPMNG, SetLocOPMNG] = useState("")
  const [locMNG, SetLocMNG] = useState("")
  const [locMobile1, SetLocMobile1] = useState("")
  const [locMobile2, SetLocMobile2] = useState("")
  const [locPhone1, SetLocPhone1] = useState("")
  const [locPhone2, SetLocPhone2] = useState("")
  const [locFax, SetLocFax] = useState("")
  const [locEmail, SetLocEmail] = useState("")
  const [locCity, SetLocCity] = useState("")
  const [locDistrict, SetLocDistrict] = useState("")
  const [locProv, SetLocProv] = useState("")
  const [locCountry, SetLocCountry] = useState("")
  const [locArea, SetLocArea] = useState("")
  const [Reason, setReason] = useState("Created")
  const [editEnable, SetEditEnable] = useState(false)

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  const [valueUpload, setvalueUpload] = useState("")
  const [items, setItems] = useState([]);
  const [Excelitems, setExcelItems] = useState([]);

  //**Set Active Tab panel */
  const [customActiveTab, setcustomActiveTab] = useState("1")
  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }


  //**Create list of tab panels */
  const tabList = [
    {
      text: "General",
      icon: "fas fa-home",
      tabID: "1",
      onClick: () => {
        toggleCustom("1")
      },
    },
    {
      text: "Contact details",
      icon: "far fa-user",
      tabID: "2",
      onClick: () => {
        toggleCustom("2")
      },
    },
  ]

  //*** User Activity related states*/
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState('')
  const [AlertColor, setAlertColor] = useState('')
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [deleteEnable, SetDeleteEnable] = useState(false)
  //*** End User activity related staes */

  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [ErrorMsg, setErrorMsg] = useState('')
  const [addNew, SetaddNew] = useState(true)

  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  const [menuCode, SetMenuCode] = useState("")


  //autocode generation related newly added code
  const [codeButton, setCodeButton] = useState(true)
  const [searchdisabled, setSearchdisabled] = useState(false)
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)
  var time = process.env.REACT_APP_ALERTTIMEOUT

  //Disable fields
  const [hideFields, setHideFields] = useState(false);
  const [disabledFields, setDisableFields] = useState([]);
  const [helpUrl, setHelpUrl] = useState("")
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL


  //import from contexts
  const {
    isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite, mobileNumberRegexp, emailRegexp
  } = useContext(Context);
  //import from contexts


  var time = process.env.REACT_APP_ALERTTIMEOUT


  //**Get File Details */
  useEffect(async () => {

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)

    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)



    var responseData = await getSelectedMasterPermissions(LogUserType, menu)

    if (!responseData.strMenuAccessRight) {
      history.push('/dashboard')
    }

    SetMenuAccess(responseData.strMenuAccessRight)
    SetMenuCreate(responseData.strMenuCreateRight)
    SetMenuDelete(responseData.strMenuDeleteRight)
    SetMenuModify(responseData.strMenuModifyRight)
    SetMenuPrint(responseData.strMenuPrintRight)
    SetMenuProcess(responseData.strMenuProcessRight)
    SetMenuName(responseData.strMenuName)
    SetMenuCode(responseData.strMenuTag)
    setPermissionReasonShow(responseData.strMenuReasonShow)
    setHelpUrl(responseData.strHelpUrl)

    var autoCodeRes = await fetchAutoCode(menu)

    if (autoCodeRes.nullCode == false) {
      setAutoCode(autoCodeRes.autoCode)
    } else {
      setNullCode(true)
      setAutoCode("")
    }
  }, [locCode])

  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu =
      menuDetail && menuDetail.menuTag
        ? menuDetail.menuTag
        : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log


    //Mark Non-Editable Content
    async function getNonEditable() {
      var requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        redirect: 'follow'
      };

      await fetch(`${ApiURL}Common/edit/${menu}`, requestOptions)
        .then(response => response.json())
        .then(result => {
          var dt = result.data[0]
          var newlist = dt != "" ? dt.strEditFeild.split(",") : []
          var hiddenFields = dt.edt_hidefields;
          setHideFields(hiddenFields);
          setDisableFields(newlist);
        }).catch(error =>
          console.log('error', error)
        );
    }

    getNonEditable();

  }, [])

  //get menu details from local storage
  // const getMenuDetails = () => {
  //   var menucodes = JSON.parse(localStorage.getItem('MenuCodes')) //all the menus available to user
  //   const menurecord = menucodes.filter(menuitem => { return menuitem.strUrl == window.location.pathname })
  //   console.log(menurecord[0], window.location.pathname);
  //   if (menurecord.length > 0) {
  //     console.log(menurecord)
  //     return menurecord[0]
  //   } else null
  // }

  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, { type: "buffer" });

        const wsname = wb.SheetNames[0];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);

        setExcelItems(data);
        resolve(data);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then((d) => {
      setItems(d);
    });
  };


  // Set values to variables

  async function ValueSetter(code) {

    if (code == "") return

    if (validateSpecialCharacters(code) == true) {
      SetCode("")
      return
    }

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")

    const result = await LocationMasterDetailsGetData(code)

    SetLoadingAlert(false)

    if (result.success == true) {

      SetActive(result.data[0].isActive)
      SetWebActive(result.data[0].isWebLoc)
      SetRemoteActive(result.data[0].isRemoteLoc)
      SetStockActive(result.data[0].isStock)
      SetIsCafe(result.data[0].intCafe)
      SetIsCompete(result.data[0].intCompte)
      SetIsLiquor(result.data[0].intLiquor)
      SetIsExtLiq(result.data[0].intExtraLiquor)
      SetCode(result.data[0].code)
      SetDesc(result.data[0].name)
      SetLocComCode(result.data[0].strCompany)
      SetLoccosCode(result.data[0].strConCode)
      SetLoclinkCode(result.data[0].strLinkCode)
      SetLocAbrCode(result.data[0].strAbrCode)
      SetLocGrade(result.data[0].strGrade)
      SetLocGroup(result.data[0].strGroup)
      SetLocSubGroup(result.data[0].strSubGroup)
      SetLocIp(result.data[0].strLocIp)
      SetLocMap(result.data[0].strMap)
      SetLocFloor(result.data[0].decFlore)
      SetLocOther(result.data[0].decOtherFl)
      SetLocTotal(result.data[0].decTotArea)
      SetLocStaff(result.data[0].decStaff)
      SetLocPosUnits(result.data[0].decBkUnits)
      SetLocParkSlots(result.data[0].decParkLots)
      SetLocBkUnits(result.data[0].decBkUnits)
      SetLocMobUnits(result.data[0].decMobUnits)
      SetLocOpDate(result.data[0].dtOpDate.slice(0, 4) == "1900" ? "" : result.data[0].dtOpDate.slice(0, 10))
      SetLocClDate(result.data[0].dtClDate.slice(0, 4) == "1900" ? "" : result.data[0].dtClDate.slice(0, 10))
      SetLocOpFrom(result.data[0].dtOpfromDate.slice(11, 19) == "00:00:00" ? "" : result.data[0].dtOpfromDate.slice(11, 19))
      SetLocOpTo(result.data[0].dtOpTodate.slice(11, 19) == "00:00:00" ? "" : result.data[0].dtOpTodate.slice(11, 19))
      SetLocGrowth(result.data[0].decGrowth)
      SetLocCurCode(result.data[0].strCurCode)
      SetLocAdd(result.data[0].strAddress1)
      SetLocAdd2(result.data[0].strAddress2)
      SetLocAdd3(result.data[0].strAddress3)
      SetLocOPMNG(result.data[0].strOpmng)
      SetLocMNG(result.data[0].strMng)
      SetLocMobile1(result.data[0].strMobile1)
      SetLocMobile2(result.data[0].strMobile2)
      SetLocPhone1(result.data[0].strPhone1)
      SetLocPhone2(result.data[0].strPhone2)
      SetLocFax(result.data[0].strFax)
      SetLocEmail(result.data[0].strEmail)
      SetLocMainLoc(result.data[0].strMAINLoc)
      SetLocPrmod(result.data[0].strPRMode)
      SetLocCity(result.data[0].strTown)
      SetLocDistrict(result.data[0].strDistrict)
      SetLocProv(result.data[0].strProvide)
      SetLocCountry(result.data[0].strCountry)
      SetLocArea(result.data[0].strArea)
      //Set Audit log details for the recalled records****
      setCrBy(result.data[0].createdBy)
      setMdBy(result.data[0].modifiedBy)
      setCrDate(result.data[0].createdDate)
      setMdDate(result.data[0].mD_DATE)
      setStoleList(result.data[0].locationRentals)

      setSaveEnable(false)
      setDisabled(true)
      SetCodeEnable(true)
      setCrEnable(true)
      SetDeleteEnable(true)
      setSearchdisabled(true)
      setReason("Updated")
      SetEditEnable(true)
    } else {
      if (nullCode == false) {
        setDisabledCode(true)
        displayAlertMessage('success', "Record Not Found !")
        SetCode("")

      } else {
        // setDisabledCode(true)
        displayAlertMessage('success', "Record Not Found !")
        // SetCode("")
      }
    }
  }





  //Clear

  const ClearItem = () => {

    setcustomActiveTab("1")
    SetActive(false)
    SetWebActive(false)
    SetRemoteActive(false)
    SetStockActive(false)
    SetIsCafe(false)
    SetIsCompete(false)
    SetIsLiquor(false)
    SetIsExtLiq(false)
    SetCode("")
    SetDesc("")
    SetLocComCode("")
    SetLoccosCode("")
    SetLoclinkCode("")
    SetLocAbrCode("")
    SetLocGrade("")
    SetLocGroup("")
    SetLocSubGroup("")
    SetLocIp("")
    SetLocMap("")
    SetLocFloor("0.0")
    SetLocOther("0.0")
    SetLocTotal("0.0")
    SetLocStaff("0.0")
    SetLocPosUnits("0")
    SetLocParkSlots("0")
    SetLocBkUnits("0")
    SetLocMobUnits("0")
    SetLocOpDate("")
    SetLocClDate("")
    SetLocOpFrom("")
    SetLocOpTo("")
    SetLocGrowth("0.0")
    SetLocCurCode("")
    SetLocAdd("")
    SetLocAdd2("")
    SetLocAdd3("")
    SetLocOPMNG("")
    SetLocMNG("")
    SetLocMobile1("")
    SetLocMobile2("")
    SetLocPhone1("")
    SetLocPhone2("")
    SetLocFax("")
    SetLocEmail("")
    SetLocMainLoc("")
    SetLocPrmod("")
    SetLocCity("")
    SetLocDistrict("")
    SetLocProv("")
    SetLocCountry("")
    SetLocArea("")
    SetCodeEnable(false)
    setCrEnable(false)
    SetDeleteEnable(false)
    SetDeleteEnable(false)
    setNullCode(false)
    setSearchdisabled(false)
    setReason("Created")
    SetEditEnable(false)
    setSaveEnable(true)
    setPermissionName("")
    setPermissionPassword("")
    setPermissionNameDisable(false)
    setExcelItems([])
    setTimeout(() => {
      setExcelItems([])
    }, 1)
    setClearData(prev => !prev)
  }

  // model trigger

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  //*** Get user selected row details */
  const GetSelectRow = (e, row, isSelect, rowIndex) => {
    SetCode(row.LOC_CODE);
    ValueSetter(row.LOC_CODE)
    setDisabled(true)
    setDisabledCode(true)
    // setSaveEnagetLocationMasterle(false)
    setmodal_xlarge(!modal_xlarge);
    // setCrBy(row.createdBy)
    // setMdBy(row.modifiedBy)
    // setCrDate(row.createdDate)
    // setMdDate(row.mD_DATE)
    setCrEnable(true)
    setSaveEnable(false)

  }
  //*** End of getSelecteData[0]ow function */

  // print Function
  async function handlePrint(option) {

    var option = option

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")

    const ReportURL = window.Links.ReportURL
    await fetch(`${ReportURL}api/Locations/report/${option == "PDF" ? 1 : 0}/${LogUserType}/${menuCode}/${locCode}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (option == "PDF") {
            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
          }
          if (option == "XCEL") {
            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
          }

        }
        SetLoadingAlert(false)
      }).catch(error => {
        console.log(error.message)
        SetLoadingAlert(false)
      })
  }
  //Toolbar Fucntions

  //edit button function    
  const handleEdit = e => {
    setDisabled(false)
    SetCodeEnable(true)
    setSaveEnable(true)
    SetaddNew(false)
    SetEditEnable(false)
  }

  //New button function
  const handleNew = e => {
    //e.preventDefault()
    ClearItem();
    setShow(false)
    setSaveEnable(true)
    SetaddNew(true)
    setCrEnable(false)
    setDisabled(false)
    SetEditEnable(false)
    setStoleList([]);
  }


  //save button function
  const handlesave = async () => {

    try {
      var ExcelItemsRows = [...Excelitems]
      if (Array.isArray(ExcelItemsRows) && ExcelItemsRows.length) {
        var rowcount = ExcelItemsRows.length
        var errorcount = 0
        var mapexport = ExcelItemsRows.map(
          async (localState) => {

            if ((localState.Code != null) && (localState.Description != null) && (localState.locComCode != null) && (addNew == true)) {

              var isActive = localState.IsActive == null ? false : localState.IsActive
              var webactive = localState.IsWebActive == null ? false : localState.IsWebActive
              var remoteactive = localState.IsRemoteActive == null ? false : localState.IsRemoteActive
              var stockactive = localState.IsStockActive == null ? false : localState.IsStockActive
              var cafe = localState.isCafe == null ? 0 : localState.isCafe
              var iscompete = localState.isCompete == null ? 0 : localState.isCompete
              var liquor = localState.isLiquor == null ? 0 : localState.isLiquor
              var extliq = localState.isExtLiq == null ? 0 : localState.isExtLiq
              var code = localState.Code
              var desc = localState.Description
              var comcode = localState.locComCode
              var coscode = localState.loccosCode == null ? "" : localState.loccosCode
              var linkcode = localState.loclinkCode == null ? "" : localState.loclinkCode
              var abrcode = localState.locAbrCode == null ? "" : localState.locAbrCode
              var grade = localState.locGrade == null ? "" : localState.locGrade
              var group = localState.locGroup == null ? "" : localState.locGroup
              var subgroup = localState.locSubGroup == null ? "" : localState.locSubGroup
              var ip = localState.locIp == null ? "" : localState.locIp
              var map = localState.locMap == null ? "" : localState.locMap
              var floor = localState.locFloor == null ? "0.0" : localState.locFloor
              var other = localState.locOther == null ? "0.0" : localState.locOther
              var total = localState.locTotal == null ? "0.0" : localState.locTotal
              var staff = localState.locStaff == null ? "0.0" : localState.locStaff
              var posunits = localState.locPosUnits == null ? "0.0" : localState.locPosUnits
              var parkslots = localState.locParkSlots == null ? "0.0" : localState.locParkSlots
              var bkunits = localState.locBkUnits == null ? "0.0" : localState.locBkUnits
              var mobunits = localState.locMobUnits == null ? "0.0" : localState.locMobUnits
              var opdate = localState.locOpDate == null ? "1900-01-01" : localState.locOpDate
              var cldate = localState.locClDate == null ? "1900-01-01" : localState.locClDate
              var opfrom = localState.locOpFrom == null ? "" : localState.locOpFrom
              var opto = localState.locOpTo == null ? "" : localState.locOpTo
              var growth = localState.locGrowth == null ? "0.0" : localState.locGrowth
              var curcode = localState.locCurCode == null ? "" : localState.locCurCode
              var locadd = localState.locAdd == null ? "" : localState.locAdd
              var locadd2 = localState.locAdd2 == null ? "" : localState.locAdd2
              var locadd3 = localState.locAdd3 == null ? "" : localState.locAdd3
              var opmng = localState.locOPMNG == null ? "" : localState.locOPMNG
              var mng = localState.locMNG == null ? "" : localState.locMNG
              var mobi1 = localState.locMobile1 == null ? "" : localState.locMobile1
              var mobi2 = localState.locMobile2 == null ? "" : localState.locMobile2
              var phone1 = localState.locPhone1 == null ? "" : localState.locPhone1
              var phone2 = localState.locPhone2 == null ? "" : localState.locPhone2
              var locfax = localState.locFax == null ? "" : localState.locFax
              var email = localState.locEmail == null ? "" : localState.locEmail
              var mainloc = localState.locMainLoc == null ? "" : localState.locMainLoc
              var prmod = localState.locPrmod == null ? "" : localState.locPrmod
              var city = localState.locCity == null ? "" : localState.locCity
              var area = localState.locArea == null ? "" : localState.locArea
              var discrict = localState.locDistrict == null ? "" : localState.locDistrict
              var prov = localState.locProv == null ? "" : localState.locProv
              var country = localState.locCountry == null ? "" : localState.locCountry


              let strResult = await setLocationMaster(
                isActive,
                webactive,
                remoteactive,
                stockactive,
                cafe,
                iscompete,
                liquor,
                extliq,
                code,
                desc,
                comcode,
                coscode,
                linkcode,
                abrcode,
                grade,
                group,
                subgroup,
                ip,
                map,
                floor,
                other,
                total,
                staff,
                posunits,
                parkslots,
                bkunits,
                mobunits,
                opdate,
                cldate,
                opfrom,
                opto,
                growth,
                curcode,
                locadd,
                locadd2,
                locadd3,
                opmng,
                mng,
                mobi1,
                mobi2,
                phone1,
                phone2,
                locfax,
                email,
                mainloc,
                prmod,
                city,
                area,
                discrict,
                prov,
                country,
                addNew,
                menuCode,
                LogCompanyCode,
                LocationCode,
                Reason,
                LogUserType
              )
              if (strResult.status == "200") {
                SetLoadingAlert(false)
                await strResult.json()
                  .then(responseData => {
                    if (responseData.data == "Record Already Exsist!") {
                      errorcount++
                    } else if (responseData.data == "Code Already Exsist!") {
                      errorcount++
                    }
                  }
                  )
              } else if (strResult.status == "400") {
                errorcount++
              } else {
                errorcount++
              }
            } else {
              errorcount++
            }
          }
        )

        await Promise.all(mapexport)
        displayAlertMessage("success", `From ${rowcount} Records  ${rowcount - errorcount} Records saved successfully and ${errorcount} Records failed to save.`)
        handleNew();



      } else {

        //set autogenerate code to as CODE just for display purpuse
        if (addNew == true && nullCode == false) {
          SetCode(autoCode)

        }

        //e.preventDefault()
        var pattern = new RegExp(mobileNumberRegexp);
        var pattern3 = new RegExp(emailRegexp);

        if (locCode.length == 0 && nullCode == true) {
          displayAlertMessage('danger', "Please Enter Code !")
          return;
        }

        if (locDec.length == 0) {
          displayAlertMessage('danger', "Please Enter Description !")
          return;
        }
        if (locComCode == 0) {
          displayAlertMessage("danger", "Please select Company !")
          return
        }
        if (locOpDate > locClDate && locClDate !== "") {
          displayAlertMessage("danger", "Closed Date should be greater than Open Date!")
          return
        }
        if (locClDate > "" && locOpDate == "") {
          displayAlertMessage("danger", "Please select open date!")
          return
        }

        if (locOpFrom > locOpTo) {
          displayAlertMessage("danger", "Closed Time should be greater than Open Time!")
          return
        }
        if (locOpTo > "" && locOpFrom == "") {
          displayAlertMessage("danger", "Please select  Open Time!")
          return
        }

        console.log(locMobile1)
        console.log(pattern.test(locMobile1))

        if (locMobile1 !== "") {
          if (!pattern.test(locMobile1)) {
            displayAlertMessage('danger', "Mobile number 1 is not Valid")
            return;

          } else if (locMobile1.length !== 10 && locMobile1.length !== 12) {
            displayAlertMessage('danger', "Mobile number 1 is wrong")
            return;

          }
        }
        if (locMobile2 !== "") {
          if (!pattern.test(locMobile2)) {
            displayAlertMessage('danger', "Mobile number 2 is not Valid")
            return;

          } else if (locMobile2.length !== 10 && locMobile2.length !== 12) {
            displayAlertMessage('danger', "Mobile number 2 is wrong")
            return;

          }
        }
        if (locPhone1 !== "") {
          if (!pattern.test(locPhone1)) {
            displayAlertMessage('danger', "Phone number 1 is not Valid")
            return;

          } else if (locPhone1.length !== 10 && locPhone1.length !== 12) {
            displayAlertMessage('danger', "Phone number 1 is wrong")
            return;

          }
        }
        if (locPhone2 !== "") {
          if (!pattern.test(locPhone2)) {
            displayAlertMessage('danger', "Phone number 2 is not Valid")
            return;

          } else if (locPhone2.length !== 10 && locPhone2.length !== 12) {
            displayAlertMessage('danger', "Phone number 2 is wrong")
            return;

          }
        }
        if (locFax !== "") {
          if (!pattern.test(locFax)) {
            displayAlertMessage('danger', "Fax number is not Valid")
            return;

          } else if (locFax.length !== 10 && locFax.length !== 12) {
            displayAlertMessage('danger', "Fax number is wrong")
            return;

          }
        }
        if (locEmail != "" & !pattern3.test(locEmail)) {
          displayAlertMessage('danger', "Email is not valid")
          return;
        }


        // Post method connect 
        //loading alert show
        SetLoadingAlert(true)
        if (addNew == true) {
          SetLoadingAlerttitle("Saving...")
        } else {
          SetLoadingAlerttitle("Updating...")
        }

        var code = addNew == true && nullCode == false ? autoCode : locCode

        var Rentals = [];
        //process location rentals
        stoleList.map((values) => {
          var loc = {}
          for (const [key, value] of Object.entries(values)) {

            loc[`${toUpper(key)}`] = value
          }
          loc.LR_LOCCODE = code;
          loc.LR_CODE = (loc.LR_CODE).toString();
          loc.LR_SQFT = parseFloat(loc.LR_SQFT);
          Rentals.push(loc);
        })

        let strResult = await setLocationMaster(
          IsActive,
          IsWebActive,
          IsRemoteActive,
          IsStockActive,
          setIntFromBool(isCafe),
          setIntFromBool(isCompete),
          setIntFromBool(isLiquor),
          setIntFromBool(isExtLiq),
          code,
          locDec,
          locComCode,
          loccosCode,
          loclinkCode,
          locAbrCode,
          locGrade,
          locGroup,
          locSubGroup,
          locIp,
          locMap,
          locFloor,
          locOther,
          locTotal,
          locStaff,
          locPosUnits,
          locParkSlots,
          locBkUnits,
          locMobUnits,
          locOpDate,
          locClDate,
          locOpFrom,
          locOpTo,
          locGrowth,
          locCurCode,
          locAdd,
          locAdd2,
          locAdd3,
          locOPMNG,
          locMNG,
          locMobile1,
          locMobile2,
          locPhone1,
          locPhone2,
          locFax,
          locEmail,
          locMainLoc,
          locPrmod,
          locCity,
          locArea,
          locDistrict,
          locProv,
          locCountry,
          addNew,
          menuCode,
          LogCompanyCode,
          LocationCode,
          Reason,
          LogUserType,
          Rentals,
        )

        if (strResult.status == "200") {
          SetLoadingAlert(false)
          strResult.json()
            .then(responseData => {
              if (responseData.data == "Record Already Exsist!") {
                displayAlertMessage('danger', responseData.data)

              } else if (responseData.data == "Code Already Exsist!") {
                displayAlertMessage('danger', responseData.data)
                setCodeButton(false)

              } else if (responseData.data == "Invalid Main Location!") {
                displayAlertMessage('danger', responseData.data)
                setCodeButton(false)

              } else {
                handleNew();
                displayAlertMessage('success', responseData.data)
              }
            }
            )
        } else if (strResult.status == "400") {
          SetLoadingAlert(false)
          strResult.json()
            .then(responseData => {
              setErrorMsg(responseData.msg)
            })

          displayAlertMessage('danger', "Oops something went wrong !")

        } else {
          SetLoadingAlert(false)
          handleNew()
        }
      }
    }
    catch {

    }
  }


  const setIntFromBool = (blParameter) => {
    if (blParameter) {
      return 1;
    } else {
      return 0;
    }
  }

  // /*********Delete button function */
  // const handleDelete = () => {


  //   const rowDelete = {
  //     "strMenuCode": menuCode,
  //     "strCode": locCode,
  //     "strLoggedCompany": LogCompanyCode,
  //     "strLoggedLocation": LocationCode,
  //     "strReason": Reason,
  //     "strCreateBy": LogUserType
  //   }
  //   //loading alert show
  //   SetLoadingAlert(true)
  //   SetLoadingAlerttitle("Deleting...")

  //   fetch(`${ApiURL}Common/Delete`,
  //     {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
  //       body: JSON.stringify(rowDelete)
  //     }
  //   ).then(Response => {
  //     if (Response.status == "200") {
  //       SetLoadingAlert(false)
  //       Response.json()
  //         .then(responseData => {
  //           console.log(responseData)
  //           if (responseData.data == "Cannot Delete, Record Already Used!") {
  //             setAlertMsg(responseData.data)
  //             setAlertColor('warning')
  //             setShow(true)
  //           } else {
  //             ClearItem();
  //             setAlertMsg(responseData.data)
  //             setAlertColor('success')
  //             setShow(true)
  //           }
  //         }
  //         )
  //     } else if (Response.status == "400") {
  //       SetLoadingAlert(false)
  //       Response.json()
  //         .then(responseData => {
  //           setErrorMsg(responseData.msg)
  //         })
  //       setAlertColor('danger')
  //       setAlertMsg("Error !")
  //       setShow(true)
  //     } else {
  //       SetLoadingAlert(false)
  //       ClearItem()
  //     }
  //   }).catch(error => {
  //     console.log(error.message)
  //   })
  //   setTimeout(() => {
  //     setShow(false)
  //   }, time)

  // }
  // //*********Delete button function end */



  /*********Delete button function */
  const handleDelete = async () => {

    const rowDelete = {
      "strMenuCode": menuCode,
      "strCode": locCode,
      "strLoggedCompany": LogCompanyCode,
      "strLoggedLocation": LocationCode,
      "strReason": Reason,
      "strCreateBy": LogUserType
    }
    //loading alert show
    SetLoadingAlert(true)
    SetLoadingAlerttitle("Deleting...")

    const result = await DeleteLocationMasterDetails(rowDelete);
    SetLoadingAlert(false)

    if (result.success) {
      displayAlertMessage("success", result.data)
      ClearItem()

    } else {

      displayAlertMessage("danger", result.data)
    }
  }
  //*********Delete button function end */

  //CODE AUTO GEN
  const AutoGenerateCode = async () => {
    await fetch(`${ApiURL}common/autocode/${menuCode}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (responseData.data.length > 0) {
            SetCode(responseData.data)
            setAutoCode(responseData.data)
          } else {
            setDisabledCode(false)
          }
        } else {
          setNullCode(true)
          setAutoCode("")
        }
      })
  }

  //**Permission Check */
  const permission = (operation) => {

    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode
    }

    clearPermissionInputs()


    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {
            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                displayAlertMessage('danger'`This user don't have permisiion to ${addNew == true ? "save " : " update "} !`)

              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")

              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")

              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "403") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "You have not Permission to make changes !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        clearPermissionInputs()

      } else {
        ClearItem()
      }
    }).catch(error => {
      console.log(error.message)
    })

  }

  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }


  //Function for displaying Alert Messages.
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setShow(true)

    setTimeout(() => {
      setShow(false)
    }, time)
  }


  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }


  const validateSpecialCharacters = (str) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return specialCharRegex.test(str);
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
          <DPAlert
            confirm_both={sweetAlertShow}
            title={menuName}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              // if (AlertConfirmOption == 1) {
              //   handlesave()
              // } else if (AlertConfirmOption == 2) {
              //   handleEdit()
              // } else if (AlertConfirmOption == 3) {
              //   window.location.href = "/";
              // } else if (AlertConfirmOption == 4) {
              //   handleNew()
              // } else if (AlertConfirmOption == 5) {
              //   SetPayHedLinkDetail(!blPayHedLinkDetail)
              //   setarRow([])
              // }
              // else if (AlertConfirmOption == 6) {
              //   handleDelete()
              // }

              if (AlertConfirmOption == 1) {

                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                history.push('/dashboard')
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 5) {
                SetPayHedLinkDetail(!blPayHedLinkDetail)
                setarRow([])
              } else if (AlertConfirmOption == 7) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Printed", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              } else if (AlertConfirmOption == 6) {

                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                  handleDelete()
                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Deleted", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              }

            }}
            onCancel={() => {
              setsweetAlertShow(false)
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={Reason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 6) {
                permission("Delete")
              } else if (AlertConfirmOption == 7) {
                permission("Print")
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPPrintOption
            confirm_both={printoptionShow}
            title={menuName}
            showCancel={true}
            cancelColor={"danger"}
            onConfirmpdf={() => {
              handlePrint("PDF")
              setprintoptionShow(false)
            }}
            onConfirmxcel={() => {
              handlePrint("XCEL")
              setprintoptionShow(false)
            }}
            onCancel={() => {
              setprintoptionShow(false)
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?");
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable && isHeadOffice}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?");
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={editEnable && isHeadOffice}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?");
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    //Print Button
                    printEnable={true}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to Print ?");
                      setAlertConfirmOption(7)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={deleteEnable}
                    deleteClick={() => {
                      setReason("Deleted")
                      setAlertDescription("Do you wish to Delete ?");
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                      // alert("Delete")
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?");
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <p />
                  <DPNavBar buttons={tabList} activeStatus={customActiveTab} />
                  <TabContent activeTab={customActiveTab} className="p-3 text">
                    {show ? (
                      <Alert color={AlertColor} role="alert">
                        {AlertMsg}
                        <br />
                        <small>{ErrorMsg}</small>
                      </Alert>
                    ) : null}
                    <TabPane tabId="1">
                      <LocationMasterGenContent
                        stoleList={stoleList}
                        setStoleList={setStoleList}
                        Loc_Active={IsActive}
                        Loc_Active_OnChange={() => {
                          SetActive(!IsActive)
                        }}
                        Loc_WebActive={IsWebActive}
                        Loc_WebActive_OnChange={() => {
                          SetWebActive(!IsWebActive)
                        }}
                        Loc_Remote={IsRemoteActive}
                        Loc_Remote_OnChange={() => {
                          SetRemoteActive(!IsRemoteActive)
                        }}
                        Loc_Stock={IsStockActive}
                        Loc_Stock_OnChange={() => {
                          SetStockActive(!IsStockActive)
                        }}

                        Loc_Cafe={isCafe}
                        Loc_Cafe_OnChange={() => {
                          SetIsCafe(!isCafe)
                        }}
                        Loc_Compete={isCompete}
                        Loc_Compete_OnChange={() => {
                          SetIsCompete(!isCompete)
                        }}
                        Loc_Liquor={isLiquor}
                        Loc_Liquor_OnChange={() => {
                          SetIsLiquor(!isLiquor)
                        }}
                        Loc_ExtLiq={isExtLiq}
                        Loc_ExtLiq_OnChange={() => {
                          SetIsExtLiq(!isExtLiq)
                        }}

                        Loc_Code={locCode}
                        onBlur={() => {
                          ValueSetter(locCode)
                        }}
                        Loc_Code_OnChange={e => {
                          let val1 = Text(
                            e.target,
                            5,
                            true,
                            false,
                            "upper",
                            false
                          )
                          SetCode(val1)
                        }}
                        Loc_Code_Enabled={codeEnable}
                        Loc_Desc={locDec}
                        Loc_Desc_OnChange={e => {
                          let val2 = Text(
                            e.target,
                            50,
                            true,
                            false,
                            "any",
                            true
                          )
                          SetDesc(val2)
                        }}
                        Loc_ComCode={locComCode}
                        Loc_ComCode_OnChange={val1 => {
                          SetLocComCode(val1["value"])
                        }}


                        Loc_MainLoc={locMainLoc}
                        Loc_MainLoc_OnChange={val1 => {
                          SetLocMainLoc(val1["value"])
                        }}

                        Loc_Prmod={locPrmod}
                        Loc_PrmodOnChange={val1 => {
                          SetLocPrmod(val1["value"])
                        }}

                        Loc_CosCode={loccosCode}
                        Loc_CosCode_OnChange={val1 => {
                          SetLoccosCode(val1["value"])
                        }}
                        Loc_LinkCode={loclinkCode}
                        Loc_LinkCode_OnChange={e => {
                          let val3 = Text(
                            e.target,
                            15,
                            true,
                            false,
                            "any",
                            true
                          )
                          SetLoclinkCode(val3)
                        }}
                        Loc_AbrCode={locAbrCode}
                        Loc_AbrCode_OnChange={e => {
                          let val3 = Text(
                            e.target,
                            15,
                            true,
                            false,
                            "any",
                            true
                          )
                          SetLocAbrCode(val3)
                        }}
                        Loc_Grade={locGrade}
                        Loc_Grade_OnChange={e => {
                          SetLocGrade(e["value"])
                        }}
                        Loc_Group={locGroup}
                        Loc_Group_OnChange={e => {
                          SetLocGroup(e["value"])
                        }}
                        Loc_SubGroup={locSubGroup}
                        Loc_SubGroup_OnChange={e => {
                          SetLocSubGroup(e["value"])
                        }}
                        Loc_CurCode={locCurCode}
                        Loc_CurCodeOnChange={e => {
                          SetLocCurCode(e["value"])
                        }}




                        Loc_Ip={locIp}
                        Loc_Ip_OnChange={e => {
                          let val3 = Text(
                            e.target,
                            50,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetLocIp(val3)
                        }}
                        Loc_Map={locMap}
                        Loc_Map_OnChange={e => {
                          let val3 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetLocMap(val3)
                        }}

                        Loc_Floor={locFloor}
                        Loc_Floor_OnChange={e => {
                          let valfl = Numeric(e.target, 10, 0, false)
                          if (valfl == "") {
                            SetLocFloor("0")
                          }
                          else {
                            SetLocFloor(valfl)
                          }
                        }}
                        FlooronBlur={e => {
                          let val1 = Numeric(e.target, 10, 0, false)
                          SetLocTotal(parseFloat(parseFloat(val1) + parseFloat(locOther)))
                        }}

                        Loc_Other={locOther}
                        Loc_Other_OnChange={e => {
                          let valOther = Numeric(e.target, 10, 0, false)

                          if (valOther == "") {
                            SetLocOther("0.0")
                          }
                          else {
                            SetLocOther(valOther)
                          }
                        }}
                        OtheronBlur={e => {
                          let val1 = Numeric(e.target, 10, 0, false)
                          SetLocTotal(parseFloat(parseFloat(val1) + parseFloat(locFloor)))
                        }}
                        locTotaldisabled={totaldisabled}
                        Loc_Total={locTotal}
                        Loc_Total_OnChange={e => {
                          let val1 = Numeric(e.target, 10, 0, false)
                          SetLocTotal(val1)
                        }}
                        TotalonBlur={e => {
                          let val1 = Numeric(e.target, 10, 0, false)
                          if (locTotal > 0 || locTotal === 0) {
                            SetLocTotal((parseFloat(locOther) + parseFloat(locFloor)))
                          }
                        }}
                        Loc_Staff={locStaff}
                        Loc_Staff_OnChange={e => {
                          let val1 = Numeric(e.target, 10, 0, false)

                          if (val1 == "") {
                            SetLocStaff("0.0")
                          }
                          else {
                            SetLocStaff(val1)
                          }
                        }}
                        Loc_ParkSlots={locParkSlots}
                        Loc_ParkSlots_OnChange={e => {
                          let val1 = Numeric(e.target, 10, 0, false)

                          if (val1 == "") {
                            SetLocParkSlots("0")
                          }
                          else {
                            SetLocParkSlots(val1)
                          }
                        }}
                        Loc_PosUnits={locPosUnits}
                        Loc_PosUnits_OnChange={e => {
                          let val1 = Numeric(e.target, 10, 0, false)

                          if (val1 == "") {
                            SetLocPosUnits("0")
                          }
                          else {
                            SetLocPosUnits(val1)
                          }
                        }}
                        Loc_BkUnits={locBkUnits}
                        Loc_BkUnits_OnChange={e => {
                          let val1 = Numeric(e.target, 10, 0, false)

                          if (val1 == "") {
                            SetLocBkUnits("0")
                          }
                          else {
                            SetLocBkUnits(val1)
                          }
                        }}
                        Loc_MobUnits={locMobUnits}
                        Loc_MobUnits_OnChange={e => {
                          let val1 = Numeric(e.target, 10, 0, false)

                          if (val1 == "") {
                            SetLocMobUnits("0")
                          }
                          else {
                            SetLocMobUnits(val1)
                          }
                        }}
                        Loc_OpDate={locOpDate}
                        Loc_OpDateOnChange={e => {

                          SetLocOpDate(e.target.value)
                        }}


                        Loc_ClDate={locClDate}
                        Loc_ClDateOnChange={e => {
                          SetLocClDate(e.target.value)
                        }}

                        Loc_OpFrom={locOpFrom}
                        Loc_OpFromOnChange={e => {

                          SetLocOpFrom(e.target.value)


                        }}

                        Loc_OpTo={locOpTo}
                        Loc_OpToOnChange={e => {

                          SetLocOpTo(e.target.value)
                        }
                        }

                        Loc_Growth={locGrowth}
                        Loc_GrowthOnChange={e => {
                          var val1 = Numeric(e.target, 10, 0, false)

                          if (val1 == "" || val1 > 100 || val1 < 0) {
                            SetLocGrowth("0.0")
                          }
                          else {
                            SetLocGrowth(val1)
                          }
                        }}

                        disabled={disabled}
                        modelTrigger={tog_xlarge}
                        modelOpen={modal_xlarge}
                        GetSelectRow={GetSelectRow}
                        ErrorMsg={ErrorMsg}
                        menuName={menuName}
                        onButtonClick={e => {
                          AutoGenerateCode()
                          setCodeButton(true)
                        }}
                        btnDisable={codeButton}
                        SearchDisable={searchdisabled}
                        showFileUpload={(e) => {
                          const file = e.target.files[0];
                          readExcel(file);
                          setvalueUpload(e.target.value)
                        }}
                        valueUpload={valueUpload}
                        menuCode={menuCode}
                        autoCode={autoCode}
                        hideFields={hideFields}
                        disabledFields={disabledFields}
                        nullCode={nullCode}
                        clearData={clearData}
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      <LocationMasterCDContent
                        menuName={menuName}
                        Loc_Add={locAdd}
                        Loc_AddOnChange={e => {
                          let val2 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetLocAdd(val2)
                        }}
                        Loc_Add2={locAdd2}
                        Loc_Add2onChange={e => {
                          let val2 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetLocAdd2(val2)
                        }}
                        Loc_Add3={locAdd3}
                        Loc_Add3OnChange={e => {
                          let val2 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetLocAdd3(val2)
                        }}
                        Loc_OPMNG={locOPMNG}
                        Loc_OPMNGOnChange={e => {
                          SetLocOPMNG(e["value"])
                        }}
                        Loc_MNG={locMNG}
                        Loc_MNGOnChange={e => {
                          SetLocMNG(e["value"])
                        }}
                        Loc_Mobile1={locMobile1}
                        Loc_Mobile1OnChange={e => {
                          let val21 = Text(e.target, 12, true, true, "any", false)
                          SetLocMobile1(val21)
                        }}
                        Loc_Mobile2={locMobile2}
                        Loc_Mobile2OnChange={e => {
                          let val22 = Text(e.target, 12, true, true, "any", false)
                          SetLocMobile2(val22)
                        }}
                        Loc_Phone1={locPhone1}
                        Loc_Phone1OnChange={e => {
                          let val22 = Text(e.target, 12, true, true, "any", false)
                          SetLocPhone1(val22)
                        }}
                        Loc_Phone2={locPhone2}
                        Loc_Phone2OnChange={e => {
                          let val22 = Text(e.target, 12, true, true, "any", false)
                          SetLocPhone2(val22)
                        }}
                        Loc_Fax={locFax}
                        Loc_FaxOnChange={e => {
                          let val22 = Text(e.target, 12, true, true, "any", false)
                          SetLocFax(val22)
                        }}
                        Loc_Email={locEmail}
                        Loc_EmailOnChange={e => {
                          let val26 = Text(
                            e.target,
                            50,
                            true,
                            true,
                            "any",
                            false
                          )
                          SetLocEmail(val26)
                        }}
                        Loc_City={locCity}
                        Loc_CityonChange={e => {
                          SetLocCity(e["value"])
                        }}
                        Loc_District={locDistrict}
                        Loc_DistrictonChange={e => {
                          SetLocDistrict(e["value"])
                        }}
                        Loc_Prov={locProv}
                        Loc_ProvonChange={e => {
                          SetLocProv(e["value"])
                        }}
                        Loc_Country={locCountry}
                        Loc_CountryonChange={e => {
                          SetLocCountry(e["value"])
                        }}
                        Loc_Area={locArea}
                        Loc_AreaOnChange={e => {
                          SetLocArea(e["value"])
                        }}
                        disabled={disabled}
                        ErrorMsg={ErrorMsg}
                        hideFields={hideFields}
                        disabledFields={disabledFields}
                      />
                    </TabPane>
                  </TabContent>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default LocationMaster
